import { AiOutlineFieldTime } from "react-icons/ai";
import { BsTags } from "react-icons/bs";
import { FiSettings, FiUsers } from "react-icons/fi";
import { RxDashboard, RxStopwatch, RxIdCard, RxGlobe } from "react-icons/rx";
import { TbBrandUnity } from "react-icons/tb";
import { FaDatabase, FaProjectDiagram } from "react-icons/fa";
import { FaUsersGear } from "react-icons/fa6";

export const navLinks = (isScaled: any) => {
  return (
    [
      {
        to: "/dashboard",
        icon: <RxDashboard size={isScaled ? 18 : 20} />,
        text: "Dashboard",
      },

      // {
      //   to: "",
      //   icon: <FiSettings size={isScaled ? 18 : 20} />,
      //   text: "Dashboard Configuration",
      // },
      {
        to: "/3d-dashboard",
        icon: <TbBrandUnity size={isScaled ? 18 : 20} />,
        text: "3D Plant",
      },
      {
        to: "/dashboard-configuration",
        icon: <BsTags size={isScaled ? 18 : 20} />,
        text: "Tags",
      },
      {
        to: "/alarms",
        icon: <RxStopwatch size={isScaled ? 18 : 20} />,
        text: "Alarms",
      },
      {
        to: "/tickets",
        icon: <RxIdCard size={isScaled ? 18 : 20} />,
        text: "Tickets",
      },
      {
        to: '/data-sources',
        icon: <FaDatabase size={isScaled ? 18 : 20} />,
        text: 'Data Sources'
      },
      // {
      //   to: "/users",
      //   icon: <FiUsers size={isScaled ? 18 : 20} />,
      //   text: "Users",
      // },
      {
        to: "/logs",
        icon: <AiOutlineFieldTime size={isScaled ? 18 : 20} />,
        text: "Logs",
      },
      {
        isExternal: false,
        to: "/projects",
        icon: <FaProjectDiagram size={isScaled ? 18 : 20} />,
        text: "Projects",
      },
      {
        isExternal: false,
        to: "/users-and-projects",
        icon: <FaUsersGear size={isScaled ? 18 : 20} />,
        text: "Users and Projects",
      }

    ]

  );
};